const validPassword = (props) => {
  /*
   * props - {id, password}
   * */
  // console.log(`${props.password}, ${props.id}`)

  if (!props.password) return '패스워드를 입력해주시기 바랍니다.'

  let type = 0
  let i = 0
  let isContinuity = false

  const num = props.password?.search(/[0-9]/g) // 숫자
  const eng = props.password?.search(/[a-z]/gi) // 영문자
  // const spe = props.password?.search(/[`~!@#$%^&*|\\\'\";:\/?]/gi) // 특수문자
  const spe = props.password?.search(/[\{\}\[\]\/?.,;:|\)*~`!^\-_+<>@\#$%&\\\=\(\'\"]/g) // 특수문자

  if (num < 0) type++
  if (eng < 0) type++
  if (spe < 0) type++

  // 연속성 검사
  for (i; i < props.password?.length - 3; i++) {
    let a = props.password.charAt(i).charCodeAt(0),
      b = props.password.charAt(i + 1).charCodeAt(0),
      c = props.password.charAt(i + 2).charCodeAt(0),
      d = props.password.charAt(i + 3).charCodeAt(0)

    if ((a - b === 1 && b - c === 1 && c - d === 1) || (a - b === -1 && b - c === -1 && c - d === -1)) {
      isContinuity = true
    }
  }

  // 조합 체크
  if (type > 1) {
    return '영문, 숫자, 특수문자 중 2가지 이상을 혼합하여 입력해주세요.'
  }

  // 공백 체크
  if (props.password?.search(/\s/) !== -1) {
    return '비밀번호는 공백없이 입력해주세요.'
  }

  // 길이 체크
  if ((type === 0 && props.password?.length < 8) || (type === 1 && props.password?.length < 10) || props.password?.length > 16) {
    return '영문, 숫자, 특수문자 중 2종류 조합시 10~16자리, 3종류 조합시 8~16자리로 구성해야합니다.'
  }

  // 연속 체크
  if (/(\w)\1\1\1/.test(props.password) || isContinuity) {
    return '동일번호 및 연속된 4자리 문자는 사용할 수 없습니다.'
  }

  if (props.id && props.password?.search(props.id) > -1) {
    return '비밀번호에 아이디가 포함되었습니다.'
  }

  return ''
}

export default validPassword
